import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  margin-bottom: 8px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  display: flex;
  gap: 8px;
  align-items: baseline;
`;

const Meta = styled.div`
  font-size: 14px;
  color: #1c1c1c;
`;

const SmallText = styled.small`
  color: #2f2f2f;
  font-size: 12px;
`;

type FieldHeaderProps = {
  title: string;
  running: number;
  total: number;
  productionPerSecond?: number;
  fuelPerSecond?: number;
};

export function FieldHeader({
  title,
  running,
  total,
  productionPerSecond,
  fuelPerSecond,
}: FieldHeaderProps) {
  const pieces: string[] = [];
  if (productionPerSecond !== undefined) {
    pieces.push(`Output: ${productionPerSecond.toFixed(2)} /s`);
  }
  if (fuelPerSecond !== undefined) {
    pieces.push(`Coal use: ${fuelPerSecond.toFixed(2)} /s`);
  }

  return (
    <Wrapper>
      <Title>
        <span>{title}</span>
        <Meta>
          {running} / {total} running
        </Meta>
      </Title>
      {pieces.length > 0 && <SmallText>{pieces.join(" • ")}</SmallText>}
    </Wrapper>
  );
}
